module.exports = __webpack_public_path__ + "static/media/ic_alert.0f14582c.svg";